export const EVENT_TYPE = {
    CREATE: 'contract:crate',
    TRANSACTION: 'contract:transaction',
    USER_REJECT: 'contract:user:reject',
    ERROR: 'contract:error',
    COMPLETE: 'contract:complete',
    BALANCE_CHANGE: 'user:balance:change',
    BATCH_CHANGE: 'user:batch:change',
};
